export default function AppDownloadCTA() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="relative rounded-3xl overflow-hidden aspect-[21/9] md:aspect-[21/7]">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20smartphone%20screen%20displaying%20glowing%20content%2C%20mysterious%20dark%20background%2C%20film%20grain%20texture%2C%20minimalist%20composition%2C%20editorial%20photography%2C%20warm%20dramatic%20lighting%2C%20high%20contrast&width=1800&height=600&seq=app-cta-bg&orientation=landscape"
              alt="今日看料 APP"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/50 to-transparent"></div>
          </div>

          <div className="text-center -mt-12 md:-mt-16 relative z-10">
            <div className="inline-block bg-background-50 rounded-2xl px-8 md:px-14 py-8 md:py-10 border border-background-200/70">
              <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 leading-tight">
                随时随地，<span className="italic font-light text-foreground-500">吃瓜不停</span>
              </h2>
              <p className="mt-3 text-foreground-500 text-sm md:text-base">
                下载今日看料 APP，第一时间获取最新爆料推送
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
                <Link to="/category/heiliao-jinri"
                  className="flex items-center gap-2 bg-foreground-950 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </Link>
                <Link to="/category/heiliao-jinri"
                  className="flex items-center gap-2 bg-foreground-950 text-background-50 px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </Link>
              </div>
              <p className="mt-4 text-foreground-400 text-xs">
                已通过安全检测 · 无病毒 · 无广告
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}